import React, { useState } from 'react';
import { CreditCard } from 'lucide-react';
import Button from '../common/Button';
import { createCheckoutSession } from '../../lib/supabase/stripe';
import { useAuth } from '../../contexts/AuthContext';
import { getProductByPriceId } from '../../stripe-config';

interface StripeCheckoutButtonProps {
  priceId: string;
  className?: string;
  children?: React.ReactNode;
}

export default function StripeCheckoutButton({ 
  priceId, 
  className, 
  children 
}: StripeCheckoutButtonProps) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const product = getProductByPriceId(priceId);

  const handleCheckout = async () => {
    if (!user) {
      // Show auth modal if not authenticated
      document.getElementById('auth-modal')?.click();
      return;
    }

    if (!product) {
      console.error('Product not found for price ID:', priceId);
      alert('Product configuration error. Please contact support.');
      return;
    }

    setLoading(true);
    try {
      await createCheckoutSession(priceId, product.mode);
    } catch (error) {
      console.error('Error creating checkout session:', error);
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      alert(`Payment setup failed: ${errorMessage}. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="primary"
      icon={CreditCard}
      onClick={handleCheckout}
      isLoading={loading}
      className={className}
    >
      {loading ? 'Processing...' : (children || `Pay $${product?.price?.toFixed(2) || '0.00'}`)}
    </Button>
  );
}